import {
  CreateInternalPhoneNumberRequest,
  InternalPhoneNumberAdminViewDto,
  UpdateInternalPhoneNumberRequest,
} from '@act/shared/data-transfer-objects';
import { EndpointDefinition } from '../utils/endpoint-definition';

export const InternalPhoneNumberRequests = {
  getAllInternalNumbers: EndpointDefinition.get<
    InternalPhoneNumberAdminViewDto[],
    null
  >({
    name: 'getAllInternalPhoneNumbers',
    route: '/users/internal-phone-number/get-all-internal-numbers',
  }),
  createInternalPhoneNumber: EndpointDefinition.post<
    InternalPhoneNumberAdminViewDto,
    CreateInternalPhoneNumberRequest,
    null
  >({
    name: 'createInternalPhoneNumberManually',
    route: '/users/internal-phone-number',
  }),
  updateInternalPhoneNumber: EndpointDefinition.patch<
    InternalPhoneNumberAdminViewDto,
    UpdateInternalPhoneNumberRequest,
    { id: string }
  >({
    name: 'updateInternalPhoneNumber',
    route: '/users/internal-phone-number/:id',
  }),
};
